import { FC } from 'react'
import Slider, { Settings } from 'react-slick'
import PerButtonCircle from '../ButtonCircle'
import 'slick-carousel/slick/slick.less'
import 'slick-carousel/slick/slick-theme.less'
import './slick-overwrite.less'

const SlickNextArrow = (props) => {
  const { className, onClick } = props
  return <PerButtonCircle size="small" icon="chevronRight_stroke" color="secondary" className={className} onClick={onClick} />
}

const SlickPrevArrow = (props) => {
  const { className, onClick } = props
  return <PerButtonCircle size="small" icon="chevronLeft_stroke" color="secondary" className={className} onClick={onClick} />
}

export const PerSlickSlider: FC<Settings> = ({
  children,
  dots = false,
  infinite = false,
  speed = 500,
  slidesToShow = 1,
  slidesToScroll = 1,
  className,
}) => {
  return (
    <Slider
      dots={dots}
      infinite={infinite}
      speed={speed}
      slidesToShow={slidesToShow}
      slidesToScroll={slidesToScroll}
      nextArrow={<SlickNextArrow />}
      prevArrow={<SlickPrevArrow />}
      className={className}
    >
      {children}
    </Slider>
  )
}
